// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"c97c9c2e","213":"ff8c661a","226":"921a3d87","286":"b9028938","384":"542fb55c","415":"d99404a3","455":"ab83dd8a","558":"25ee8f07","707":"1bc11a54","794":"1be20a43","807":"8dcf0399","821":"d3433899","879":"3481d16c","889":"b717c534","970":"de41a453"}[chunkId] + ".chunk.js";
};